import { ReactElement } from "react";

import { ICustomization } from "../../apis/useGetOrderDetail/types";
import { centsToDollarsDisplay } from "../../common/helpers/stringUtils";
import Condition from "../../components/Conditional/Condition";
import I18nText from "../../components/I18nText/I18nText";

interface IProps {
	customizations: ICustomization[];
}

const OrderConfirmationCustomizations = ({ customizations }: IProps): ReactElement => {
	return (
		<ul className="CartItemCustomizations">
			{customizations.map((customization) => (
				<li className="Customization" key={customization.food_supplier_customization_id}>
					<span className="CustomizationTitle">
						<I18nText enText={customization.title_en} cnText={customization.title_cn} />:
					</span>
					<ul className="Options">
						{customization.food_supplier_customization_option.map((option) => (
							<li key={option.food_supplier_customization_option_id} className="Option">
								<I18nText
									className="OptionTitle"
									enText={option.title_en}
									cnText={option.title_cn}
								/>
								<Condition check={option.price > 0}>
									<span className="OptionPrice TabularNums">{`+ $${centsToDollarsDisplay(option.price)}`}</span>
								</Condition>
							</li>
						))}
					</ul>
				</li>
			))}
		</ul>
	);
};

export default OrderConfirmationCustomizations;
